
import { defineComponent } from 'vue';
import ImagePreview from "@/app/ui/views/pusat-resolusi-v2/components/image-preview.vue";
import downloadFile from "@/app/infrastructures/misc/common-library/DownloadFile";
import fileNameFromUrl from "@/app/infrastructures/misc/common-library/FileNameFromUrl";
import fileExtensionFromUrl from "@/app/infrastructures/misc/common-library/FileExtensionFromUrl";
import { AttachmentData } from '@/domain/entities/PusatResolusiV2';

export default defineComponent({
  components: {
    ImagePreview
  },
  props: {
    issueName: {
      type: String as () => string,
      required: true
    },
    description: {
      type: String as () => string,
      required: true
    },
    attachment: {
      type: Array as () => AttachmentData[],
      default: () => []
    }
  },
  data() {
    return {
      isExpanded: false,
      showImagePreview: false,
      selectedImage: null as number | null,
    }
  },

  computed: {
    shouldShowToggle(): boolean {
      if (!this.description) return false;
      return this.description.length > 100;
    }
  },

  methods: {
    toggleExpand(): void {
      this.isExpanded = !this.isExpanded;
    },
    
    openImagePreview(index: number): void {
      this.selectedImage = index;
      this.showImagePreview = true;
    },

    closeImagePreview(): void {
      this.showImagePreview = false;
      this.selectedImage = null;
    },

    isImageFile(ext?: string): boolean {
      return ["png", "jpg", "jpeg", "gif", "webp", "mp4", "webm"].includes(
        ext?.toLowerCase() ?? ""
      );
    },

    isPdfFile(ext?: string): boolean {
      return ext?.toLowerCase() === "pdf";
    },

    getFileColor(ext?: string): string {
      if (!ext) return "#EDEDED";

      const lowerExt = ext.toLowerCase();
      switch (lowerExt) {
        case "doc":
        case "docx":
          return "#155EEF";
        case "pdf":
          return "#AD0C00";
        case "xlsx":
          return "#016F3E";
        case "xls":
          return "#079455";
        case "csv":
          return "#EDEDED";
        default:
          return "#EDEDED";
      }
    },

    getFileExtension(filename: string): string {
      return filename.split('.').pop() || '';
    },

    downloadFile(url: string): void {
      downloadFile(url, fileNameFromUrl(url), fileExtensionFromUrl(url));
    },
    openInNewTab(url: string): void {
      const newWindow = window.open(url, '_blank');
      if (newWindow) newWindow.opener = null;
    }
  }
});
